import { defineMessages } from 'react-intl'

/** Shared i18n message descriptors for brand config strings */

export const leConfigMessages = defineMessages({
  searchBarText: {
    id: 'BijKy3abfC0B5VLOxR0o',
    defaultMessage: 'Search great offers for',
    description: 'Search bar placeholder text for Luxury Escapes family brands',
  },
  searchFormTitle: {
    id: '_lc0nBKTiDOmhUb7jaGo',
    defaultMessage: 'The world’s best escapes, handpicked by experts',
    description: 'Hero section title for Luxury Escapes family search form',
  },
  headMetaTitle: {
    id: 'asMhqxxhS1snrlyF5GAH',
    defaultMessage: 'Handpicked Escapes at the Best Prices on Earth',
    description: 'Meta title suffix for destination product pages (Luxury Escapes)',
  },
  headDefaultTitle: {
    id: 'Fmi5C6Gw7shBZlGUs3jK',
    defaultMessage: 'Luxury Escapes - Handpicked Escapes at the Best Prices on Earth',
    description: 'Default page title for Luxury Escapes',
  },
  headDefaultDescription: {
    id: 'P2mYLATFpx090J7i8Z84',
    defaultMessage: 'Find the latest luxury travel ideas & exclusive special offers at insider prices. Save on holiday travel & accommodation packages with Luxury Escapes.',
    description: 'Default meta description for Luxury Escapes',
  },
})

export const whiteLabelConfigMessages = defineMessages({
  searchBarText: {
    id: '1cp4crcANJeAHx--69rl',
    defaultMessage: 'Search',
    description: 'Search bar placeholder text for white-label brands',
  },
  searchFormTitle: {
    id: 'yq1_Bk95h9WsCimdG7Ad',
    defaultMessage: 'The best value holidays are right here',
    description: 'Hero section title for white-label brand search form',
  },
  headMetaTitle: {
    id: 'OGVT4jPEMpBsswgxgwAb',
    defaultMessage: 'Travel Deals & Holiday Package Deals',
    description: 'Meta title suffix for destination product pages (white-label brands)',
  },
  headDefaultDescription: {
    id: 'VT-TpyGFNAGbx2jFZBLD',
    defaultMessage: 'Travel is the one thing you buy that makes you richer. Check out travel deals & holiday package deals for your next adventure. Grab a bargain today!',
    description: 'Default meta description for white-label brands',
  },
})

export const cudoConfigMessages = defineMessages({
  headDefaultTitle: {
    id: 'wRvW_uZyt9EHptL93x6T',
    defaultMessage: 'Travel Deals & Holiday Package Deals | Cudo',
    description: 'Default page title for Cudo',
  },
})

export const dealsConfigMessages = defineMessages({
  headDefaultTitle: {
    id: 'HdHC6pN39InxWqDrNPrH',
    defaultMessage: 'Travel Deals & Holiday Package Deals | Deals',
    description: 'Default page title for Deals',
  },
})

export const scooponConfigMessages = defineMessages({
  headDefaultTitle: {
    id: 'Rtnd0NV09KOEDK-1FXvA',
    defaultMessage: 'Travel Deals & Holiday Package Deals | Scoopon',
    description: 'Default page title for Scoopon',
  },
})

export const treatmeConfigMessages = defineMessages({
  headDefaultTitle: {
    id: 'N2DWcydfz-EyLQBrn--s',
    defaultMessage: 'Travel Deals & Holiday Package Deals | TreatMe',
    description: 'Default page title for TreatMe',
  },
})

export const leAgentHubConfigMessages = defineMessages({
  headMetaTitle: {
    id: 'cyzWYLZspkV81g6ETNmm',
    defaultMessage: 'LE Agent Hub - Earn commission on the world’s best travel deals',
    description: 'Meta title suffix for destination product pages (LE Agent Hub)',
  },
  headDefaultTitle: {
    id: 'bf2CNVP7GDJmhbpATJsV',
    defaultMessage: 'LE Agent Hub - Earn commission on the world’s best travel deals',
    description: 'Default page title for LE Agent Hub',
  },
  headDefaultDescription: {
    id: 'XcbWTf9Vg1kIJyGuZo5j',
    defaultMessage: 'The only way to get access to Luxury Escapes Exclusive travel offers - give your clients access to the very best offers globally',
    description: 'Default meta description for LE Agent Hub',
  },
})

export const cvfrConfigMessages = defineMessages({
  headMetaTitle: {
    id: 'dcaMNUSPEcjEoFlIoAe3',
    defaultMessage: 'CVFR Holidays - Earn commission on the world\'s best travel deals',
    description: 'Meta title suffix for destination product pages (CVFR Holidays)',
  },
  headDefaultTitle: {
    id: 'txDDFbH8kxz7SfF7Hybd',
    defaultMessage: 'CVFR Holidays - Earn commission on the world\'s best travel deals',
    description: 'Default page title for CVFR Holidays',
  },
})

/** Shared message descriptors for "How it works" / "Why book with us" cards */
export const howItWorksMessages = defineMessages({
  // Tour offer type (shared: base, white-label, LE Agent Hub, CVFR)
  tourBestPriceGuaranteeTitle: {
    id: 'tMZS7wYi8tuAuf0H906P',
    defaultMessage: 'Best Price Guarantee',
    description: 'How it works card title: Best Price Guarantee (tour)',
  },
  tourBestPriceGuaranteeContent: {
    id: 'wp4slVksKGlOLelvh-Dm',
    defaultMessage: 'Found a better price? We’ll match it… plus more.',
    description: 'How it works card content: Best Price Guarantee (tour)',
  },
  tourHandpickedPartnersTitle: {
    id: 'OsFBVCv490zIC-OH8qDA',
    defaultMessage: 'Handpicked Partners',
    description: 'How it works card title: Handpicked Partners (tour)',
  },
  tourHandpickedPartnersContent: {
    id: 'Hh2H6TJB9T703g_k-Jmh',
    defaultMessage: 'We work with the world’s most loved brands in travel',
    description: 'How it works card content: Handpicked Partners (tour)',
  },
  tourCuratedByExpertsTitle: {
    id: 'qml8R0DtWXMszCqBdI6v',
    defaultMessage: 'Curated By Tour Experts',
    description: 'How it works card title: Curated By Tour Experts (tour)',
  },
  tourCuratedByExpertsContent: {
    id: 'O2BJTU7LfwFnPiC7pmC0',
    defaultMessage: 'Saving you time researching and planning',
    description: 'How it works card content: Curated By Tour Experts (tour)',
  },
  // Hotel offer type (base config / LE family)
  hotelWePriceMatchTitle: {
    id: '7ZkPgwvqLEhkFSqUKpny',
    defaultMessage: 'We price match',
    description: 'How it works card title: We price match (hotel, LE family)',
  },
  hotelWePriceMatchContent: {
    id: 'iBWRldEvrJp3_fpwtjGo',
    defaultMessage: 'If you find a better price, we’ll match it',
    description: 'How it works card content: We price match (hotel)',
  },
  hotelChangeOfMindRefundTitle: {
    id: 'wVWnf1lIwYLO7A64ecdt',
    defaultMessage: '7-day ‘change of mind’ refund',
    description: 'How it works card title: 7-day change of mind refund (hotel)',
  },
  hotelChangeOfMindRefundContent: {
    id: 'MafTtf7AK9FqKVtflbvt',
    defaultMessage: 'Get a full refund on your booking (excludes flights, experiences and the service fee paid on deposit bookings)',
    description: 'How it works card content: 7-day change of mind refund (hotel)',
  },
  hotelVipInclusionsTitle: {
    id: 'YoNd6hQlBABpfRdPgCLq',
    defaultMessage: 'VIP Inclusions',
    description: 'How it works card title: VIP Inclusions (hotel)',
  },
  hotelVipInclusionsContent: {
    id: '_duhQZwHwYz2ZxA8Qfjg',
    defaultMessage: 'You get a lot more than just a bed in a room',
    description: 'How it works card content: VIP Inclusions (hotel)',
  },
  hotelBuyNowTitle: {
    id: 'aq7z2mOeRQZVXK4CB5hH',
    defaultMessage: 'Buy now, choose dates later',
    description: 'How it works card title: Buy now, choose dates later (hotel)',
  },
  hotelBuyNowContent: {
    id: 'bMCGXeF2ayTGhRxwQIp_',
    defaultMessage: 'Lock in a deal today, choose dates when you’re ready',
    description: 'How it works card content: Buy now, choose dates later (hotel)',
  },
  // Last minute hotel offer type (base config / LE Agent Hub / CVFR)
  lmhUnbeatableValueTitle: {
    id: 'sQtmKz06962SlcCvkydj',
    defaultMessage: 'Unbeatable value',
    description: 'How it works card title: Unbeatable value (last minute hotel)',
  },
  lmhUnbeatableValueContent: {
    id: '_Na4zMlkx1dZONqI1gQ0',
    defaultMessage: 'Up to 15% (or more) off the best available rate',
    description: 'How it works card content: Unbeatable value (last minute hotel)',
  },
  lmhExclusiveExtrasTitle: {
    id: 'wVQXwL-A-icFCzhZQiq8',
    defaultMessage: 'Exclusive extras',
    description: 'How it works card title: Exclusive extras (last minute hotel)',
  },
  lmhExclusiveExtrasContent: {
    id: 'mBYoV8HVF0RgomO_Xudb',
    defaultMessage: 'Special inclusions to add a touch of luxury',
    description: 'How it works card content: Exclusive extras (last minute hotel)',
  },
  lmhHandPickedHotelsTitle: {
    id: 'QRiUVTcer1xbfPgeD5g_',
    defaultMessage: 'Hand picked hotels',
    description: 'How it works card title: Hand picked hotels (last minute hotel)',
  },
  lmhHandPickedHotelsContent: {
    id: 'G95ZlbHzYskQ7zVtkVhC',
    defaultMessage: 'The best hotels and resorts, curated by our team of experts',
    description: 'How it works card content: Hand picked hotels (last minute hotel)',
  },
  lmhInstantBookingTitle: {
    id: 'cBMO81qX48pwF4eRSfoV',
    defaultMessage: 'Instant booking',
    description: 'How it works card title: Instant booking (last minute hotel)',
  },
  lmhInstantBookingContent: {
    id: '6pnPOMl_g4yc5Jo_RHpl',
    defaultMessage: 'Book with ease and get instant confirmation of your stay',
    description: 'How it works card content: Instant booking (last minute hotel)',
  },
  // White-label hotel (Cudo, Deals, Scoopon, TreatMe)
  wlHotelBestPricesTitle: {
    id: 'MXmyre6vHaqxV21LTSqJ',
    defaultMessage: 'Best prices',
    description: 'How it works card title: Best prices (white-label hotel)',
  },
  wlHotelBestPricesContent: {
    id: 'N93LwdlDptE1XNp87UbK',
    defaultMessage: 'We go direct to ensure you get the best price possible',
    description: 'How it works card content: Best prices (white-label hotel)',
  },
  wlHotelPurchaseWithConfidenceTitle: {
    id: 'kBqbnMesrkn84rnGbqKQ',
    defaultMessage: 'Purchase with confidence',
    description: 'How it works card title: Purchase with confidence (white-label hotel)',
  },
  wlHotelPurchaseWithConfidenceContent: {
    id: 'UH2AWPIiD_AnaVs88M3J',
    defaultMessage: "We offer a 7-day 'Change of Mind' no questions asked guarantee",
    description: 'How it works card content: Purchase with confidence (white-label hotel)',
  },
  wlHotelQualityGuaranteedTitle: {
    id: 'warvFTakbcr-lY7UxY_o',
    defaultMessage: 'Quality guaranteed',
    description: 'How it works card title: Quality guaranteed (white-label hotel)',
  },
  wlHotelQualityGuaranteedContent: {
    id: 'DGbo_RhdCbrXAQmo1PMm',
    defaultMessage: 'We test the beds to assure you have an amazing holiday',
    description: 'How it works card content: Quality guaranteed (white-label hotel)',
  },
  // LE Agent Hub hotel (different title casing from base)
  agentHubHotelBestPriceTitle: {
    id: 'G0MI2FGG-R48BZg0z_PU',
    defaultMessage: 'Best price guarantee',
    description: 'How it works card title: Best price guarantee (LE Agent Hub hotel)',
  },
})

/** Shared message descriptors for static page titles used across brand configs */
export const staticPageMessages = defineMessages({
  support: {
    id: 'CNgc8akU-yBjU2fGTRMI',
    defaultMessage: 'Support',
    description: 'Static page title: Support',
  },
  termsAndConditions: {
    id: 'kxm86wwucbdVW4wDgDgr',
    defaultMessage: 'Terms & Conditions',
    description: 'Static page title: Terms & Conditions',
  },
  bookingPolicies: {
    id: 'TH81nlFYCRDHKCHawWZG',
    defaultMessage: 'Booking & Refund Policies',
    description: 'Static page title: Booking & Refund Policies',
  },
  privacyPolicy: {
    id: 'h8r37AbnFdcErdVdMAKW',
    defaultMessage: 'Privacy Policy',
    description: 'Static page title: Privacy Policy',
  },
  flights: {
    id: 'rS4qX0m8ZalDT0uh2Sbc',
    defaultMessage: 'Flights',
    description: 'Static page title: Flights',
  },
  frequentFlyerPrograms: {
    id: '41Pl7lmB-_--_uaG7-yU',
    defaultMessage: 'Frequent Flyer Programs',
    description: 'Static page title: Frequent Flyer Programs',
  },
  bestPriceGuarantee: {
    id: 'UwrGNlkqofOocSXe4VwK',
    defaultMessage: 'Best Price Guarantee',
    description: 'Static page title: Best Price Guarantee',
  },
  luxuryEscapesGiftCards: {
    id: '521FDdHUKU9K33JQtgIT',
    defaultMessage: 'Luxury Escapes Gift Cards',
    description: 'Static page title: Luxury Escapes Gift Cards',
  },
  specialProductsPromotions: {
    id: '1A4i9VhLIiSdRCR1ctmD',
    defaultMessage: 'Special Products & Promotions',
    description: 'Static page title: Special Products & Promotions',
  },
  refundPolicy: {
    id: '8H0bdAHFizksxOoDHJVB',
    defaultMessage: 'Refund Policy',
    description: 'Static page title: Refund Policy',
  },
  aboutUs: {
    id: 'WzDYbUky38onJUXqh_kq',
    defaultMessage: 'About Us',
    description: 'Static page title: About Us',
  },
  careersAndCulture: {
    id: 'DiX_uwSX7A42GIDLISF5',
    defaultMessage: 'Careers & Culture',
    description: 'Static page title: Careers & Culture',
  },
  travelProtection: {
    id: 'BlzNRqrUVHYBVKKYJoNr',
    defaultMessage: 'Travel Protection',
    description: 'Static page title: Travel Protection',
  },
  travelProtectionXcover: {
    id: 'v1b3ApC5UA5Q0cxNP9LD',
    defaultMessage: 'Travel Protection - xcover',
    description: 'Static page title: Travel Protection - xcover',
  },
  contactUs: {
    id: 'QQBH2uRd5v0cwM9gjFrl',
    defaultMessage: 'Contact Us',
    description: 'Static page title: Contact Us',
  },
  latestNews: {
    id: 'ai1torrmVq1MC1xfo8zC',
    defaultMessage: 'Latest News',
    description: 'Static page title: Latest News',
  },
  buyNowChooseDatesLater: {
    id: 'GfSSujn5Pnlvp1THlq5L',
    defaultMessage: 'Buy now, choose dates later',
    description: 'Static page title: Buy now, choose dates later',
  },
  tourWithConfidence: {
    id: 'Ujx7iSvEDdFwrDlwAn4s',
    defaultMessage: 'Tour with confidence',
    description: 'Static page title: Tour with confidence',
  },
  escapeWithConfidence: {
    id: 'FpgYrQzxtZhPun4HMQ9l',
    defaultMessage: 'Escape with confidence',
    description: 'Static page title: Escape with confidence',
  },
  becomeAnAffiliatePartner: {
    id: 'HhtsqJriKPYO45yxrbPT',
    defaultMessage: 'Become an Affiliate Partner',
    description: 'Static page title: Become an Affiliate Partner',
  },
  luxPlusTermsAndConditions: {
    id: 'oTp6XFUYTtyxnsxfN5W7',
    defaultMessage: 'LuxPlus+ Terms & Conditions',
    description: 'Static page title: LuxPlus+ Terms & Conditions',
  },
  societeTermsAndConditions: {
    id: '4umBNh9ApdcFJLkaywlq',
    defaultMessage: 'Société Terms & Conditions',
    description: 'Static page title: Société Terms & Conditions',
  },
  societeFAQs: {
    id: 'uTR1-ebxnAIW9nC8GSTE',
    defaultMessage: 'Société FAQs',
    description: 'Static page title: Société FAQs',
  },
  shopFAQs: {
    id: 'UTWiFaz8KUfCQ6dy8v5p',
    defaultMessage: 'Shop FAQs',
    description: 'Static page title: Shop FAQs',
  },
  shopTermsAndConditions: {
    id: '-YycImDs0TYI_SzEs9z4',
    defaultMessage: 'Shop Terms And Conditions',
    description: 'Static page title: Shop Terms And Conditions',
  },
  directMaldivesFlights: {
    id: 'IxQa3pA55Hu_EXYVTIsI',
    defaultMessage: 'Direct Maldives Flights',
    description: 'Static page title: Direct Maldives Flights (LE Agent Hub)',
  },
})

/** Shared message descriptors for loyalty unit labels */
export const loyaltyUnitMessages = defineMessages({
  pointsCount: {
    id: 'k-L29JVu4VGHJUa6iyGx',
    defaultMessage: '{count, plural, one {# point} other {# points}}',
    description: 'Loyalty points count, e.g. "5 points"',
  },
  pointsAbbreviationCount: {
    id: 'Qe18-R8EGrh2T5DeJjgy',
    defaultMessage: '{count, plural, one {# pt} other {# pts}}',
    description: 'Abbreviated loyalty points count, e.g. "5 pts"',
  },
  bonusPointsCount: {
    id: 'Z0DJvtV0QGhahJgXRzYf',
    defaultMessage: '{count, plural, one {# bonus point} other {# bonus points}}',
    description: 'Loyalty bonus points count, e.g. "5 bonus points"',
  },
  bonusPointsAbbreviationCount: {
    id: 'LpwdDXrvm5WNx7O3eOgr',
    defaultMessage: '{count, plural, one {# bonus pt} other {# bonus pts}}',
    description: 'Abbreviated loyalty bonus points count, e.g. "5 bonus pts"',
  },
  statusCreditsCount: {
    id: 'a5W01EYIIMZ5EdYUewxP',
    defaultMessage: '{count, plural, one {# status credit} other {# status credits}}',
    description: 'Loyalty status credits count, e.g. "5 status credits"',
  },
  pointsAbbreviationPlural: {
    id: 'eamURWA8Wv13yL5yCM0m',
    defaultMessage: 'pts',
    description: 'Abbreviated loyalty points unit (always plural), e.g. "pts" in "500 pts"',
  },
})
